<script setup>
import {ref, onMounted, getCurrentInstance} from 'vue'
import { useRoute, useRouter } from 'vue-router'
import SNB from "../../../../layouts/nav/SNB.vue";
import { usePageLoadingStore } from "../../../../stores/pageLoading";
import mypageProposalService from "@/pages/user/services/mypage/mypageProposalService";
import KSATextButton from "../../../../components/ui-components/button/KSATextButton.vue";
import MyPageResumeModal from "../../components/modal/mypage/MyPageResumeModal.vue";
import {useAlertStore} from "@/stores/alertStore";
import mypageCorpInfoService from "@/pages/user/services/mypage/mypageCorpInfoService";
import {useUserStore} from "@/pages/user/stores/user";
import {storeToRefs} from "pinia";
import JobFairCorpInfoModal from "@/pages/user/components/modal/jobFair/JobFairCorpInfoModal.vue";
const { $alert, $confirm} = useAlertStore();

const globals = getCurrentInstance().appContext.config.globalProperties;
const { $toast, $pageListBoardNo, $yyyymmddHHmmss } = globals;

const userStore = useUserStore();
const { user } = storeToRefs(userStore);

const route = useRoute();
const router = useRouter();
const loadingStore = usePageLoadingStore()

const snbKey = ref(0);

onMounted(() => {
  retrieveList();
});

const list = ref([])
const currentPage = ref(1);
const pageSize = ref(10);
const totalPages = ref(1);
const totalCount = ref(0);

const corpInfoModal = ref(null);
const userMatchingResumeModal = ref(null);

const pageSizeGroup = ref([
  { label:"10개씩 보기", value: "10" },
  { label:"30개씩 보기", value: "30" },
  { label:"50개씩 보기", value: "50" },
  { label:"100개씩 보기", value: "100" },
])

// 페이지당 개수 변경
const onSelectPageSize = (option) => {
  pageSize.value = option.value;
  currentPage.value = 1;
  retrieveList();
}

// 페이지 클릭
const onSelectPage = (pageNo) => {
  currentPage.value = pageNo;
  retrieveList();
}

const retrieveList = () => {
  let paramObj = {
    userId: user.value.userCd,
    pageNumber: currentPage.value,
    size: pageSize.value,
  };

  loadingStore.loading = true;
  mypageCorpInfoService.retrieveApplicantListPagingByUserId(paramObj)
      .then( async (res) => {
        loadingStore.loading = false;
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          totalPages.value = result.totalPages;
          totalCount.value = result.totalElements;
          list.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
        }
        loadingStore.loading = false;
      }).catch( (error) =>  {
    // $alert("데이터를 받아오지 못했습니다.기업코드 등록여부를 확인해주세요.");
    console.log(error);
    loadingStore.loading = false;
  });
}

// 기업정보 보기
const onClickViewCorp = async (corpId) => {
  let viewSource = 'promotion'

  corpInfoModal.value.init(false);
  corpInfoModal.value.retrieveCorporation(corpId, 0, viewSource);
  corpInfoModal.value.show();
}

// 이력서 보기
const onClickViewResume = async (resumeId) => {
  userMatchingResumeModal.value.init(false);
  userMatchingResumeModal.value.retrieveApplicantResume(resumeId, 0);
  userMatchingResumeModal.value.show();
}

// 입사지원 상태변경
const onClickApplyStateGb = async (corpId, resumeId, stateGb) => {
  if (stateGb === "01") {
    stateGb = "02"
  }
  const ok = await $confirm(["지원을 취소 하시겠습니까?", "'지원취소'로 상태가 변경됩니다."], "지원 취소");
  if(!ok) {
    return -1;
  } else {
    let paramObj = {
      corpId: corpId,
      resumeId: resumeId,
      applyStateGb: stateGb,
    }
    mypageCorpInfoService.updateApplyStateGb(paramObj)
        .then( (res) => {
          loadingStore.loading = false;
          if(res.data.code.toLowerCase() === 'success') {
            //const result = res.data.result;
            $alert("변경하였습니다.");
            //$toast('', "삭제를 하였습니다.")

            retrieveList();
          } else {
            $alert("변경을 실패하였습니다.");
            console.log(res);
          }
        })
        .catch( (res) =>  {
          loadingStore.loading = false;
          $alert("변경을 실패하였습니다.");
        });
  }
}
</script>

<template>
  <div class="container">
    <div class="inner">
      <div class="flex-wrap">
        <SNB :key="snbKey" class="snb" />
        <div class="content">
          <div class="sub-title">
            <h3>기업 입사지원 현황</h3>
          </div>
          <div class="list-top">
            <p>총 <span>{{ $number(totalCount) }}</span>건</p>
            <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize"/>
          </div>
          <div class="table-form board-mobile-vertical">
            <table>
              <tr>
                <th>번호</th>
                <th>기업명</th>
                <th>이력서보기</th>
                <th>관심 카테고리</th>
                <th>입사 지원일</th>
                <th>상태</th>
                <th>상태 변경</th>
              </tr>
              <tr v-for="applyList in list">
                <td>{{ applyList.boardNo }}</td>
                <td class="clickable blue text-overflow long-overflow" @click="onClickViewCorp(applyList.corpId)">{{ applyList.corpName }}</td>
                <td>
                  <KSATextButton class="clickable" text="이력서 보기" @click="onClickViewResume(applyList.resumeId)"/>
                </td>
                <td>{{ applyList.interests }}</td>
                <td>{{ $yyyymmddHHmmss(applyList.createDate) }}</td>
                <td>
                  <span v-if="applyList.applyStateGb === '01'">{{ $gbNameKR('APPLY_STATE_GB',applyList.applyStateGb) }}</span>
                  <span v-else-if="applyList.applyStateGb === '03' || applyList.applyStateGb === '05'" class="blue">{{ $gbNameKR('APPLY_STATE_GB',applyList.applyStateGb) }}</span>
                  <span v-else-if="applyList.applyStateGb === '04' || applyList.applyStateGb === '06'" class="red">{{ $gbNameKR('APPLY_STATE_GB',applyList.applyStateGb) }}</span>
                  <span v-else class="gray">{{ $gbNameKR('APPLY_STATE_GB',applyList.applyStateGb) }}</span>
                </td>
                <td>
                  <div v-if="applyList.applyStateGb === '01'">
                    <KSATextButton class="clickable black_button" text="지원취소" @click="onClickApplyStateGb(applyList.corpId, applyList.resumeId, '02')"/>
                  </div>
                  <div v-else>
                    -
                  </div>
                </td>
              </tr>
              <tr v-if="list.length === 0">
                <td colspan="7">입사지원 내역이 없습니다.</td>
              </tr>
            </table>
          </div>
          <Paginate
              v-if="list.length > 0"
              v-model="currentPage"
              :page-count="totalPages"
              :click-handler="onSelectPage"
          />
        </div>
      </div>
    </div>
  </div>
  <JobFairCorpInfoModal ref="corpInfoModal"/> <!-- 기업정보 보기 -->
  <MyPageResumeModal ref="userMatchingResumeModal"/>
</template>


<style lang="scss" scoped>
@import "../../../../assets/scss/theme";
.blue {
  color: $blue_color;
}
.red {
  color: $red_color;
}
.gray {
  color: $gray_color;
}

.clickable {
  cursor: pointer;
  text-decoration: underline;
  color: #3C72FF;
}
</style>
